import { fork } from 'redux-saga/effects';
import { ordersConfigWatcher } from './documentsSaga';
import { filtersConfigWatcher } from './filtersSaga';

export default function* Documents() {
  yield fork(ordersConfigWatcher);
  yield fork(filtersConfigWatcher);
}
